module.exports = __webpack_public_path__ + "static/media/pause.cede8e3e.svg";